import { Controller } from '@hotwired/stimulus'

// format url for calling products#show or samples#show
// with the correct params
// also allow url to reflect the actual variant
// to allow sharing urls more effectively
export default class extends Controller {
  static targets = [
    'printType',
    'addToCartButton',
    'input',
  ]

  static values = {
    currentPrintType: { type: String, default: 'photo_prints' },
  }

  connect = () => {
    this.baseUrl = window.location.toString().split('?')[0]
  }

  disableControls = () => {
    this.addToCartButtonTarget.disabled = true
    this.inputTargets.forEach((element) => { element.disabled = true })
  }

  selectPrintType = (event) => {
    this.disableControls()
    this.url = new URL(this.baseUrl)
    this.currentPrintTypeValue = event.target.value
    this.url.searchParams.append('print_type', this.currentPrintTypeValue)

    window.location.href = this.url.href
  }

  updateSelectedVariant = () => {
    this.disableControls()
    this.updateUrl()

    window.location.href = this.url.href
  }

  updateUrl = () => {
    this.url = new URL(this.baseUrl)
    this.url.searchParams.append('print_type', this.currentPrintTypeValue)

    this.inputTargets.forEach((element) => {
      if (element instanceof window.HTMLSelectElement) {
        this.url.searchParams.append(element.name, element.value)
      }
      else if (element instanceof window.HTMLInputElement && element.checked) {
        this.url.searchParams.append(element.name, element.value)
      }
    })
  }
}
